import React, { useState } from 'react';
import ReactStars from 'react-rating-stars-component';
import { RxCross1 } from 'react-icons/rx';
import { PiHouseLight } from 'react-icons/pi';
import { toast } from 'react-toastify';
import { useAuth0 } from '@auth0/auth0-react';
import axios from 'axios';
import messageicon from '../assets/message.svg'
import company from '../assets/company.svg'
import contact from '../assets/contact.svg'
import name from '../assets/name.svg'
import { RxCrossCircled } from "react-icons/rx";

const FeedbackForm = ({ setfeedback }) => {
    const { getIdTokenClaims } = useAuth0();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        phone: '',
        brokerage: '',
        service_rating: 0,
        feedback: ''
    });

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleRatingChange = (newRating) => {
        setFormData({ ...formData, service_rating: newRating });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const idTokenClaims = await getIdTokenClaims();
            const idToken = idTokenClaims.__raw;

            await axios.post(`https://${import.meta.env.VITE_REACT_APP_API_ENDPOINT}/feedback`, formData, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${idToken}`,
                },
            });

            toast.success('Thank you for your feedback!',{
                autoClose: 2000, });
            setLoading(false);
            setTimeout(() => {
                setfeedback(false);
            }, 2000);
        } catch (error) {
            toast.error('Failed to submit feedback. Please try again later.');
            setLoading(false);
        }
    };

    return (
        <div className='flex z-30 justify-center px-2  w-full py-3 absolute '>
            <div>
                <div className='bg-[#0062FF] rounded-tl-2xl rounded-tr-2xl h-12 w-full'>
                    <div onClick={() => setfeedback(false)} className='flex justify-end pr-4 pt-1 text-gray-300 cursor-pointer hover:text-red-400'>
                        <RxCrossCircled size={30} />
                    </div>
                </div>
                <form onSubmit={handleSubmit} className='px-6 py-4 bg-white rounded-bl-3xl rounded-br-2xl'>
                    <div className='grid grid-cols-2 gap-3'>
                        <div className='flex flex-col gap-2 '>
                            <h1 className='font-semibold text-md'>Name</h1>
                            <div className='flex shadow-lg border-2 rounded-full py-2.5 px-4'>
                                <input
                                    className='w-full sm:text-auto text-sm outline-none'
                                    placeholder='Your name'
                                    type="text"
                                    name="name"
                                    id="name"
                                    onChange={handleChange}
                                />
                                <img className='w-[1rem] sm:w-[1.3rem]' src={name} alt="" />
                            </div>
                        </div>
                        <div className='flex flex-col gap-2 '>
                            <h1 className='font-semibold text-md'>Email</h1>
                            <div className='flex shadow-lg border-2 rounded-full py-3 px-4'>
                                <input
                                    className='w-full sm:text-auto text-sm outline-none'
                                    placeholder='Email Address'
                                    type="email"
                                    name="email"
                                    id="email"
                                    onChange={handleChange}
                                />
                                <img  className='w-[1rem] sm:w-[1.4rem]'  src={messageicon} alt="" />
                            </div>
                        </div>
                    </div>
                    <div className='grid grid-cols-2 gap-3 pt-8'>
                        <div className='flex flex-col gap-2 '>
                            <h1 className='font-semibold text-md'>Phone Number</h1>
                            <div className='flex shadow-lg border-2 rounded-full py-2.5 px-4'>
                                <input
                                    className='w-full sm:text-auto text-sm outline-none'
                                    placeholder='(123) 456-7890'
                                    type="text"
                                    name="phone"
                                    id="phone"
                                    onChange={handleChange}
                                />
                                <img className='w-[.7rem] sm:w-[1rem]'  src={contact} alt="" />
                            </div>
                        </div>
                        <div className='flex flex-col gap-2 '>
                            <h1 className='font-semibold text-md'>Brokerage</h1>
                            <div className='flex shadow-lg border-2 rounded-full py-1.5 sm:py-2.5  px-4'>
                                <input
                                    className='w-full sm:text-auto text-sm outline-none'
                                    placeholder='Company'
                                    type="text"
                                    name="brokerage"
                                    id="brokerage"
                                    onChange={handleChange}
                                />
                                <PiHouseLight style={{ height: '22px', width: '30px' }} className='text-gray-400'/>
                            </div>
                        </div>
                    </div>
                    <div className=''>
                        <h1 className='font-semibold text-md pt-4'>Your experience using Deli</h1>
                        <ReactStars
                            count={5}
                            onChange={handleRatingChange}
                            size={40}
                            activeColor="#ffd700"
                            name="service_rating"
                        />
                    </div>
                    <div className='pb-3'>
                        <h1 className='py-2'>What would you like us to know?</h1>
                        <textarea
                            id="feedback"
                            rows="4"
                            className="block p-2.5 w-full text-sm border rounded-lg"
                            placeholder="Your message..."
                            name="feedback"
                            onChange={handleChange}
                        ></textarea>
                    </div>
                    <div className='flex items-center gap-2'>
                        <button
                            type="submit"
                            className='py-3 rounded-full flex justify-center items-center bg-[#0062FF] text-white px-5 transition-transform duration-300 hover:scale-105'
                            disabled={loading}
                        >
                            {loading ? 'Submitting...' : 'Submit feedback'}
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
};

export default FeedbackForm;
